var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { CardHeader, Badge } from 'reactstrap';
import classnames from 'classnames';
var CordataCardHeader = function CordataCardHeader(_ref) {
  var inverse = _ref.inverse,
    color = _ref.color,
    children = _ref.children,
    action = _ref.action,
    badge = _ref.badge,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ['inverse', 'color', 'children', 'action', 'badge', 'className']);
  var classes = classnames('bg-' + color, {
    'text-light': inverse
  }, className);
  var actionClasses = classnames({
    'd-flex justify-content-between align-items-center': !!action || !!badge
  });
  return React.createElement(CardHeader, _extends({
    className: classes
  }, props), React.createElement('div', {
    className: actionClasses
  }, children, (badge || action) && React.createElement('span', null, badge && React.createElement(Badge, null, badge), action)));
};
CordataCardHeader.propTypes = {
  inverse: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string])
};
CordataCardHeader.defaultProps = {
  inverse: false,
  color: 'default',
  className: '',
  badge: undefined,
  action: ''
};
export default CordataCardHeader;